import React, { useEffect, useState } from "react";
import { Alert, Text, View } from "react-native";
import { Activity, Search, ShieldCheck } from "lucide-react-native";
import { api } from "../api/client";
import { Badge, Button, Card, DataTable, Field, ScreenHeader, Select, Toolbar } from "../components/UI";
import { colors, styles } from "../styles";

export function LogsScreen() {
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({ action: "", entity_type: "", date_from: "", date_to: "" });

  const load = () => api.logs(filters).then(setRows).catch((error) => Alert.alert("Logs", error.message));

  useEffect(() => { load(); }, []);

  return (
    <View style={styles.page}>
      <ScreenHeader title="System Activity Logs" subtitle="Audit trail for users, quotations, products, clients, and security operations" />

      <Card style={{ padding: 16 }}>
        <Toolbar>
          <Field label="Action Filter" value={filters.action} onChangeText={(v) => setFilters({ ...filters, action: v })} placeholder="e.g. login, create, update..." />
          <Select label="Entity Type" value={filters.entity_type} onChangeText={(v) => setFilters({ ...filters, entity_type: v })}>
            <option value="">All Entities</option>
            <option value="user">User</option>
            <option value="quotation">Quotation</option>
            <option value="client">Client</option>
            <option value="product">Product</option>
            <option value="settings">Settings</option>
          </Select>
          <Field label="Date From" value={filters.date_from} onChangeText={(v) => setFilters({ ...filters, date_from: v })} placeholder="YYYY-MM-DD" />
          <Field label="Date To" value={filters.date_to} onChangeText={(v) => setFilters({ ...filters, date_to: v })} placeholder="YYYY-MM-DD" />
          <Button icon={Search} onPress={load}>Filter Audit Logs</Button>
        </Toolbar>
      </Card>

      <DataTable
        columns={[
          { key: "created_at", label: "Date & Time", style: { fontWeight: "600" } },
          { key: "user_name", label: "User Account", render: (r) => r.user_name || "System Administrator" },
          {
            key: "action",
            label: "Action",
            render: (r) => (
              <Badge variant={r.action.includes("login") ? "info" : r.action.includes("created") || r.action.includes("save") ? "success" : "secondary"}>
                {r.action}
              </Badge>
            )
          },
          { key: "entity_type", label: "Entity Type", render: (r) => String(r.entity_type || "-").toUpperCase() },
          { key: "entity_id", label: "Entity ID", render: (r) => r.entity_id || "-" },
          {
            key: "new_value",
            label: "Audit Details",
            render: (r) => (r.new_value || r.old_value || "").slice(0, 100),
            style: { flex: 2 }
          }
        ]}
        rows={rows}
      />
      <Text style={styles.small}>Showing latest matching audit trail log entries.</Text>
    </View>
  );
}
